export default {
  required: (value) => !!value || "必須入力項目です",
  choice2: (value) => value.length === 2 || "2つ選択してください",
  counter: (value) => value.length <= 20 || "20文字以内で入力してください",
  counter2: (value) =>
    (!!value && value.length === 2) || "2文字で入力してください",
  counter3: (value) =>
    (!!value && value.length === 3) || "3文字で入力してください",
  counterMin4: (value) =>
    (!!value && value.length <= 4) || "4文字以内で入力してください",
  counter14to16: (value) =>
    (!!value && value.length >= 14 && value.length <= 16) ||
    "14〜16文字で入力してください",
  counter100: (value) =>
    !value ||
    (typeof value === "string" && value.length <= 100) ||
    "100文字以内で入力してください",
  counter500: (value) =>
    !value ||
    (typeof value === "string" && value.length <= 500) ||
    "500文字以内で入力してください",
  counter1000: (value) =>
    !value ||
    (typeof value === "string" && value.length <= 1000) ||
    "1000文字以内で入力してください",
  typeNumber: (value) =>
    !value ||
    (typeof value === "number" && value < -2147483648 && value > 2147483647) ||
    "数値で入力してください",
  typeStringNumber: (value) => {
    const pattern = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
    return pattern.test(value) || "数値で入力してください";
  },
  email: (value) => {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || "メールアドレスの形式で入力してください";
  },
  phoneNumber: (value) => {
    if (value === null || value === "") {
      return true;
    }
    // 電話番号の形式チェック
    const pattern = /^0\d{1,4}-\d{1,4}-\d{4}$/;
    return pattern.test(value) || "半角数字と半角ハイフンで入力してください";
  },
  postalCode: (value) => {
    if (value === null || value === "") {
      return true;
    }
    // 郵便番号の形式チェック
    const pattern = /^[0-9]{3}-[0-9]{4}$/;
    return pattern.test(value) || "半角数字と半角ハイフンで入力してください";
  },
  noAnySpace: (value: string | null | undefined) => {
    if (value === null || value === undefined || value === "") {
      return true;
    }
    // 全角・半角スペース、タブ、改行などの空白文字を含むかチェック
    const pattern = /[\s ]/;
    return !pattern.test(value) || "スペースなどの空白文字は入力できません";
  },
  integerThan0: (value) => {
    const pattern = /^\d*$/;
    return pattern.test(value) || "0以上の整数で入力してください";
  },
  multipleSelectRequired: (value: []) => value.length > 0 || "必須入力項目です",
  typeKana: (value) => {
    if (!value) {
      return true;
    }
    const pattern = /^[\u3041-\u3096]+$/;
    return pattern.test(value) || "ひらがなで入力してください";
  },
  typeAlphabet: (value) => {
    if (!value) {
      return true;
    }
    const pattern = /^[a-zA-Z\s]*$/;
    return pattern.test(value) || "半角英字で入力してください";
  },
};
